module.exports = __webpack_public_path__ + "img/train_banner.33331448.png";